import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ScoopsPage from "../pages/scoops/page";
import ScoopDetailPage from "../pages/scoop-detail/page";
import VerifyPage from "../pages/verify/page";
import AboutPage from "../pages/about/page";
import ContactPage from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/scoops",
    element: <ScoopsPage />,
  },
  {
    path: "/scoop/:id",
    element: <ScoopDetailPage />,
  },
  {
    path: "/verify",
    element: <VerifyPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;